import React, { Component } from 'react'

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import MuiSelect from '@material-ui/core/Select';

import './Select.css'

class Select extends Component {

    /* Lifecycle */
     
    render() {

        const { inputLabel, name, onChange, value, menuItems } = this.props

        return (
            <FormControl className="pages-shared-comparator-filters-select" fullWidth={true}>
                <InputLabel htmlFor={name}>{inputLabel}</InputLabel>
                <MuiSelect
                    value={value}
                    onChange={onChange}
                    inputProps={{
                        name: name,
                        id: name,
                    }}>
                    {
                        menuItems.map((menuItem, index) => {
                            return (
                                <MenuItem key={index} value={menuItem.value}>
                                    <img className="pages-shared-comparator-filters-select__icon" src={menuItem.icon}/> &nbsp; { menuItem.label }
                                </MenuItem>
                            )
                        })   
                    }
                </MuiSelect>
            </FormControl>
        )
    }
}

export default Select


// WEBPACK FOOTER //
// ./src/components/pages/shared/comparator_filters/Select.js